import "./error.css";

const ErrorPage = ({ isErrorOccured }) => {
  return (
    <div className="b2b-com-layout mdl-layout mdl-layout--fixed-header mdl-js-layout mdl-color--grey-100">
      <header className="b2b-com-header mdl-layout__header mdl-layout__header--scroll mdl-color--grey-100 mdl-color-text--grey-800">
        <div className="mdl-layout__header-row">
          <span className="mdl-layout-title">Sysco B2B Punchout</span>
        </div>
      </header>

      <div className="b2b-com-ribbon"></div>

      <main className="b2b-com-main mdl-layout__content">
        <div className="b2b-com-container mdl-grid">
          <div className="mdl-cell mdl-cell--2-col"></div>
          <div className="b2b-com-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col">
            <h3>We're sorry, but something went wrong.</h3>
            <p>
              Please contact Sysco B2B Operational Support at{" "}
              <a href="mailto:000-BT-B2B-Modernization@Sysco.onmicrosoft.com">
                000-BT-B2B-Modernization@Sysco.onmicrosoft.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
